import Vue from "vue"

let observer

// Example: v-visible="{ active: true, target: '#target', callback: (isIntersecting)=> {}, options: { root: document.querySelector('#scrollArea'), rootMargin: '0px', threshold: 1.0 } }"
Vue.directive('visible', {
  bind(el, binding, vnode) {
    let active = binding.value && binding.value.active
    let callback = binding.value && binding.value.callback
    let options = binding.value && binding.value.options || {}
    let target = binding.value && binding.value.target || 'body'
    let target_el = el.querySelector(target)

    let onIntersect = (entries, _observer) => {
      callback(entries[0].isIntersecting, entries[0].intersectionRatio)
    }

    if (active && callback) {
      observer = new IntersectionObserver(onIntersect, options)
      observer.observe(target_el)
    }
  },
  unbind () {
    observer = null
  }
})




// WEBPACK FOOTER //
// ./src/directives/Visible.js